import * as types from 'generated/graphql';

import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const Document: ITypeSpecificPolicy<types.Document> = {
  fields: {
    createdTimestamp: dateTimeFieldPolicy(),
    updatedTimestamp: dateTimeFieldPolicy()
  }
};
